<template>
  <div class="col-sm-12">
    <div class="card">
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th scope="col" class="text-center">Nro</th>
              <th scope="col" class="text-center" style="max-width: 250px">
                Título
              </th>
              <th scope="col" class="text-center">Usuario</th>
              <th scope="col" class="text-center">Estado</th>
              <th scope="colgroup" colspan="2" class="text-center">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="paginatedItems.length > 0">
              <tr v-for="(item, index) in paginatedItems" :key="item.id">
                <th scope="row">
                  {{ (currentPage - 1) * itemsPerPage + index + 1 }}
                </th>
                <td class="text-center">{{ item.title }}</td>
                <td class="text-center">
                  {{ item.user?.name }} {{ item.user?.first_last_name }}
                  {{ item.user?.second_last_name }}
                </td>
                <td class="text-center">
                  <span
                    v-if="item.inbox === 0"
                    class="badge bg-secondary btn-sm p-2"
                  >
                    <i class="fa fa-clock-o"></i> Borrador
                  </span>
                  <span
                    v-else-if="item.inbox === 1"
                    class="badge btn-sm p-2"
                    style="background-color: #8754ff"
                  >
                    <i class="fa fa-paper-plane"></i> Enviado
                  </span>
                  <span
                    v-else-if="item.inbox === 2"
                    class="badge bg-warning btn-sm p-2"
                  >
                    <i class="fa fa-hourglass-half"></i> En Revisión
                  </span>
                  <span
                    v-else-if="item.inbox === 3"
                    class="badge bg-success btn-sm p-2"
                  >
                    <i class="fa fa-check"></i> Aprobado
                  </span>
                  <span
                    v-else-if="item.inbox === 4"
                    class="badge bg-info btn-sm p-2"
                  >
                    <i class="fa fa-exclamation-triangle"></i> Observado
                  </span>
                  <span
                    v-else-if="item.inbox === 5"
                    class="badge bg-danger btn-sm p-2"
                  >
                    <i class="fa fa-times"></i> Rechazado
                  </span>
                </td>
                <td class="text-center">
                  <div class="btn-group">
                    <button
                      class="btn btn-secondary"
                      @click="openEditModal(item)"
                      title="Editar el evento"
                    >
                      <i class="fa fa-edit"></i>
                    </button>
                    <button
                      v-if="item.inbox === 4"
                      class="btn btn-info"
                      @click="showObservation(item)"
                      title="Ver motivo de observación"
                    >
                      <i class="fa fa-eye"></i>
                    </button>
                    <button
                      v-if="item.inbox === 5"
                      class="btn btn-danger"
                      @click="showRejection(item)"
                      title="Ver motivo de rechazo"
                    >
                      <i class="fa fa-eye"></i>
                    </button>
                    <button
                      v-if="item.inbox === 4"
                      class="btn btn-primary"
                      @click="resendEvent(item)"
                      title="Reenviar el evento a revisión"
                    >
                      <i class="fa fa-send"></i>
                    </button>
                    <button
                      v-if="item.inbox === 0"
                      class="btn btn-primary"
                      @click="changeState(item)"
                      title="Enviar el evento a revisión"
                    >
                      <i class="fa fa-send"></i>
                    </button>
                  </div>
                </td>
                <td class="text-center">
                  <button
                    class="btn btn-danger"
                    @click="() => concludeEvent(item)"
                    :disabled="!canConclude(item)"
                    title="Concluir Evento"
                  >
                    Concluir
                  </button>
                </td>
              </tr>
            </template>
            <tr v-else>
              <td colspan="6" class="text-center py-4 text-muted">
                <EmptyState
                  title="No se encontraron eventos."
                  :size="450"
                  fontSize="fs-5"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <pagination
        :totalItems="props.list.length"
        :itemsPerPage="itemsPerPage"
        @page-change="handlePageChange"
      />
    </div>
  </div>

  <ObservationModal
    ref="observationModal"
    :event="selectedEvent"
    @acknowledged="handleObservationAcknowledged"
  />

  <RejectionModal
    ref="rejectionModal"
    :event="selectedEvent"
    @acknowledged="handleRejectionAcknowledged"
  />
  <ModalEditEvent
    ref="editModal"
    :eventData="selectedEvent"
    @updated="emit('reloadList')"
  />
</template>

<script setup>
import { ref, computed, inject } from "vue";
import Pagination from "@/pages/components/Pagination.vue";
import ObservationModal from "../components/EventModalObserved.vue";
import RejectionModal from "../components/EventModalRejected.vue";
import ModalEditEvent from "../components/ModalUpdate.vue";
import EmptyState from "@/components/emptyState.vue";
import axios from "@/includes/connection";
import { toast } from "vue3-toastify";

const editModal = ref(null);
const swal = inject("$swal");

function openEditModal(item) {
  selectedEvent.value = item;
  editModal.value?.showModal();
}

const props = defineProps({ list: Array });
const emit = defineEmits(["reloadList"]);

const observationModal = ref(null);
const rejectionModal = ref(null);
const selectedEvent = ref({});

const list = computed(() => {
  return props.list;
});

function canConclude(item) {
  const now = new Date();
  const endDate = new Date(item.end_date);
  return item.inbox === 3 && now > endDate;
}

async function concludeEvent(item) {
  swal
    .fire({
      title: "¿Está seguro?",
      text: "Esta acción concluirá el evento.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Cancelar",
      confirmButtonText: "Sí, concluir",
      focusCancel: true,
      reverseButtons: true,
    })
    .then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(`/event/${item.id}/conclude`)
          .then((response) => {
            swal.fire({
              icon: "success",
              title: "Evento concluido",
              text: "El evento se concluyó correctamente.",
            });
            item.state = 3;
            emit("reloadList");
          })
          .catch((error) => {
            if (error.response && error.response.status === 404) {
              swal.fire({
                icon: "error",
                title: "No encontrado",
                text: "Evento no encontrado o no autorizado.",
              });
            } else if (error.response && error.response.status === 400) {
              swal.fire({
                icon: "error",
                title: "Solicitud inválida",
                text: "No se puede concluir el evento.",
              });
            } else {
              console.error("Error concluyendo el evento:", error);
              swal.fire({
                icon: "error",
                title: "Error",
                text: "Ocurrió un error al concluir el evento.",
              });
            }
          });
      }
    });
}

const changeState = (item) => {
  //console.log("item", item);
  swal
    .fire({
      title: "Confirmar Envío",
      text: "¿Está seguro de enviar este evento a comunicación?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Cancelar",
      confirmButtonText: "Sí, enviar",
      focusCancel: true,
      reverseButtons: true,
    })
    .then((result) => {
      if (result.isConfirmed) {
        axios
          .patch("/event/" + item.id)
          .then((response) => {
            console.log("change state");
            toast.success("Operación exitosa, Evento enviado a comunicación.");
            emit("reloadList");
          })
          .catch(function (error) {
            toast.error("Operación fallida, verifique el estado del evento.");
            console.log("change error", error);
            emit("reloadList");
          });
      }
    });
};

const resendEvent = (item) => {
  swal
    .fire({
      title: "Confirmar Reenvío",
      text: "¿Está seguro de reenviar este evento a comunicación?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Cancelar",
      confirmButtonText: "Sí, reenviar",
      focusCancel: true,
      reverseButtons: true,
    })
    .then((result) => {
      if (result.isConfirmed) {
        axios
          .patch("/event/" + item.id + "/resend")
          .then((response) => {
            console.log("resend event");
            toast.success("Evento reenviado exitosamente a comunicación.");
            emit("reloadList");
          })
          .catch(function (error) {
            console.log("resend error", error);
            toast.error("Error al reenviar el evento. Verifique el estado.");
            emit("reloadList");
          });
      }
    });
};

const showObservation = (item) => {
  selectedEvent.value = item;
  observationModal.value.show();
};

const showRejection = (item) => {
  selectedEvent.value = item;
  rejectionModal.value.show();
};

const handleObservationAcknowledged = (event) => {
  toast.info(
    "Observación revisada. Puede realizar las correcciones necesarias."
  );
};

const handleRejectionAcknowledged = (event) => {
  toast.info(
    "Rechazo revisado. Puede crear un nuevo evento con las correcciones."
  );
};

let currentPage = ref(1);
let itemsPerPage = ref(10);

const sortedList = computed(() => {
  return [...props.list].sort((a, b) => b.id - a.id);
});

let paginatedItems = computed(() => {
  const startIndex = (currentPage.value - 1) * itemsPerPage.value;
  const endIndex = startIndex + itemsPerPage.value;
  return sortedList.value.slice(startIndex, endIndex);
});

function handlePageChange(page) {
  currentPage.value = page;
}
</script>
